import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { canAccessRoute } from '../../utils/accessControl';

export default function RequireAccess({
  children,
  minimumRole,
  anyRoles,
  fallbackPath = '/app',
}) {
  const { user } = useAuth();
  const allowed = canAccessRoute(user?.roles || [], { minimumRole, anyRoles });

  if (!allowed) {
    return <Navigate to={fallbackPath} replace />;
  }

  return children;
}
